class CustomTabsContainer extends HTMLElement {
  constructor() {
    super();

    this.tabs = this.querySelectorAll('.content-tabs__tab');
    this.contents = this.querySelectorAll('.content-tab__content');
  }

  connectedCallback() {
    this.listenEvents();
  }

  listenEvents() {
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        this.openCurrentTab(tab);
      });
    });
  }

  /**
   * @param {Event} event
   */

  openCurrentTab(tab) {
    this.onTabSelection(tab);
  }

  /**
   * @param {Event} event
   * @param {String} id
   */

  onTabSelection(currentTab) {
    this.tabs.forEach((tab) => {
      tab.classList.remove('active');

      if (tab.id === currentTab.id) {
        tab.classList.add('active');
      }
    });

    this.contents.forEach((content) => {
      content.classList.add('hidden');

      if (content.dataset.id === currentTab.id) {
        content.classList.remove('hidden');
      }
    });
  }
}

customElements.define('custom-tabs-container', CustomTabsContainer);

class CustomTab extends HTMLElement {
  constructor() {
    super();
    this.buttonShowMore = this.querySelector('.image-with-text-tab__more-button');
    this.contentShowMore = this.querySelector('.image-with-text-tab__more-content');
  }

  connectedCallback() {
    this.listenEvents();
  }

  listenEvents() {
    this.buttonShowMore?.addEventListener('click', (event) => {
      this.toggleShowMore(event);
    });
  }

  toggleShowMore() {
    if (this.buttonShowMore) {
      if (this.buttonShowMore.classList.contains('show_more')) {
        this.buttonShowMore.classList.remove('show_more');
        this.buttonShowMore.classList.add('show_less');
        this.buttonShowMore.innerHTML = this.querySelector('.show-less-label').innerHTML;
        if (this.contentShowMore) this.contentShowMore.classList.remove('hidden');
      } else {
        this.buttonShowMore.classList.remove('show_less');
        this.buttonShowMore.classList.add('show_more');
        this.buttonShowMore.innerHTML = this.querySelector('.show-more-label').innerHTML;
        if (this.contentShowMore) this.contentShowMore.classList.add('hidden');
      }
    }
  }
}

customElements.define('custom-tab', CustomTab);
